import type { PuzzleEvent, PuzzleMatchState } from "../simulation";

export type PuzzleSnapshotListener = (state: PuzzleMatchState) => void;
export type PuzzleEventsListener = (events: PuzzleEvent[]) => void;

/** Disposable message boundary between the authoritative state and Phaser. */
export class PuzzleSceneBridge {
  private state: PuzzleMatchState | null = null;
  private readonly snapshotListeners = new Set<PuzzleSnapshotListener>();
  private readonly eventListeners = new Set<PuzzleEventsListener>();

  publishSnapshot(state: PuzzleMatchState): void {
    this.state = state;
    this.snapshotListeners.forEach((listener) => listener(state));
  }

  publishEvents(events: PuzzleEvent[]): void {
    if (events.length === 0) return;
    this.eventListeners.forEach((listener) => listener(events));
  }

  latestSnapshot(): PuzzleMatchState | null {
    return this.state;
  }

  onSnapshot(listener: PuzzleSnapshotListener): () => void {
    this.snapshotListeners.add(listener);
    return () => this.snapshotListeners.delete(listener);
  }

  onEvents(listener: PuzzleEventsListener): () => void {
    this.eventListeners.add(listener);
    return () => this.eventListeners.delete(listener);
  }

  clear(): void {
    this.state = null;
    this.snapshotListeners.clear();
    this.eventListeners.clear();
  }
}
